import { QueryClient } from '@tanstack/react-query';

// =============================================================================
// Singleton TanStack Query client. Diexport supaya auth-store.logout bisa
// clear semua cache tanpa harus lewat React context (useQueryClient hook).
// =============================================================================

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
